<nav class="navbar navbar-expand-lg navbar-dark bg-danger fixed-top">
  <div class="navbar-brand mr-auto">Coatings Security Cameras</div>
  <div>
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" (click)="retry()" role="button">Home</a>
      </li>
      <li>
        <a class="nav-link" (click)="logout()" role="button">Logout</a>
      </li>
    </ul>
  </div>
</nav>
<div class="container">
  <h3>Application Error</h3>
  <ngb-alert [dismissible]="false">
    <h5>{{ error.errorType }}</h5>
    <p class="">
      {{ this.error.errorMessage }}
    </p>
  </ngb-alert>

  <p>Please contact Coatings Application Support</p>
</div>
